import { PROVIDER_PROPOSAL_RESPONSE_KEY } from 'utils/constants';

export function getAbsoluteLink(url: string) {
  if (url.includes('http')) {
    return url;
  }
  return `//${url}`;
}

export function removeResponseProgressLocalStorage() {
  // Loop to remove all data provider proposal responses progres from localStorage
  // WE store each response progress with the kwy patterm PROVIDER_PROPOSAL_RESPONSE_KEY-proposalId-searchId
  for (const key in localStorage) {
    const regex = new RegExp(`${PROVIDER_PROPOSAL_RESPONSE_KEY}-.`);
    if (regex.test(key)) {
      localStorage.removeItem(key);
    }
  }
}
